import { createApp, markRaw } from "vue";
import "normalize.css/normalize.css";
import "./Styles/index.scss"; // 全局 css
import ElementPlus from "element-plus";
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import "element-plus/dist/index.css";
import moment from "moment";
import _ from "lodash";
import "./public-path";
import App from "./App.vue";
import Actions from "./Utils/QiankunState";
import { TinyEmitter } from "tiny-emitter";
import router, { asyncRoutes, constantRoutes } from "./Router";
import { createRouter, createWebHistory } from "vue-router";
import { createPinia } from 'pinia';
import "./Permission";
import * as Settings from "./settings";
const emitter = new TinyEmitter();
import AutoSavePageState from "./Directive/AutoSavePageState/index";
import AutoFocus from "./Directive/AutoFocus/index";
import TcWebBuried from "./../public/tc-web-buried";
import VueClipboard from 'vue-clipboard2';
import * as echarts from 'echarts';

// 这里如果是开发环境才使用mock数据
if (Settings.isDevelopMode && Settings.useMock) {
  const { mockXHR } = require("../mock");
  mockXHR();
}
// 该埋点配置详情参见技术中心前端埋点sdk说明
var OPTIONS = {
  useImgSend: false,
  openClick: true,
  openXhrQuery: false,
  systemName: Settings.projectName,
  logName: 'tc_web_burid',
  postUrl: 'https://tech.seasungame.com/client/push/app_200001006/',
  selector: '.tcbury input',
  classTag: 'tcbury'
};

moment.locale("zh-cn");

/**
 * 渲染函数 两种情况：主应用生命周期中运行/ 微应用单独运行
 */
let instance = null;
let routerForQiankun = null;
let history = null;
function renderBySelf() {
  instance = createApp(App);
  const pinia = createPinia();
  pinia.use(({ store }) => { store.$router = markRaw(router); });
  instance.use(ElementPlus, { locale: zhCn }).use(pinia).use(router).mount("#app");
  instance.use(AutoSavePageState).use(AutoFocus);

  instance.use(TcWebBuried, OPTIONS);
  instance.use(VueClipboard);
  instance.config.globalProperties._ = _;
  instance.config.globalProperties.$moment = moment;
  // 绑定为全局可用
  instance.config.globalProperties.bus = emitter;
}

function renderByQiankun(props) {
  const { container } = props;
  if (props) {
    // 接收主应用传过来的通信参数
    Actions.setActions(props);
  }


  let _mainSysName = "TcMicroMain"
  if(props.mainSysName  != undefined){
    _mainSysName = props.mainSysName
  }
  history = createWebHistory('/'+_mainSysName +'/' + Settings.projectName);
  routerForQiankun = createRouter({
    // 运行在主应用中时，添加路由命名空间 /vue
    history,
    routes: [...asyncRoutes, ...constantRoutes],
  });
  const pinia = createPinia();
  pinia.use(({ store }) => { store.$router = markRaw(routerForQiankun); });
  instance = createApp(App);
  instance
    .use(ElementPlus, { locale: zhCn })
    .use(pinia)
    .use(routerForQiankun)
    .mount(container.querySelector("#app"));
  instance.use(AutoSavePageState).use(AutoFocus);
  instance.use(TcWebBuried, OPTIONS);
  instance.use(VueClipboard);
  instance.config.globalProperties._ = _;
  instance.config.globalProperties.$moment = moment;
  // 绑定为全局可用
  instance.config.globalProperties.bus = emitter;
}

if (!window.__POWERED_BY_QIANKUN__) {
  renderBySelf();
}

export async function bootstrap() {
  console.log("vue3.0 micro bootstrap");
}

export async function mount(props) {
  console.log("micro mount", props);
  renderByQiankun(props);
}

export async function unmount() {
  console.log("micro unmount");
  instance.unmount();
  instance._container.innerHTML = "";
  instance = null;
  routerForQiankun = null;
  history.destroy();
}
